import * as React from "react";
function SvgBoxes(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      strokeWidth={2}
      fill="none"
      stroke="currentColor"
      ref={svgRef}
      {...props}
    >
      <path d="M10 22H7a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4" />
      <rect width={18} height={18} x={10} y={10} rx={2} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBoxes);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
